import React, { memo } from "react";

interface IProps {
  data: {
    link: string;
    name: string;
  }[];
  title: string;
}

const TagsColumn: React.FC<IProps> = ({ data, title }) => {
  return (
    <>
      {data.length !== 0 && (
        <div className="w-full py-20 px-0">
          <p className="text-28 font-[700] text-left text-[#333333] leading-[34px] mb-18">{title}</p>

          <div className="flex flex-wrap w-full gap-20">
            {data.map((item) => (
              <React.Fragment key={item.name}>
                {!!item.name && (
                  <a href={item.link} className="px-8 py-4 bg-[#e8e8e8] rounded-[16px] text-16 text-center text-[#666666] hover:text-[#666666] leading-[18px]">
                    {item.name}
                  </a>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default memo(TagsColumn);
